$(document).ready(function () {
    if ( !$.fn.DataTable.isDataTable( '.dataTable' ) ) {

        if($('.dataTable').hasClass('descending-order-table')){
            dt = $('.dataTable').DataTable({
                responsive: true,
                pageLength: 50,
                "order": [0,'desc'],
                columnDefs: [
                  { targets: 'js-no-sort', orderable: false }
                ]
            });
        } else {
            dt = $('.dataTable').DataTable({
                ordering: true,
                responsive: true,
                pageLength: 50,
                columnDefs: [
                  { targets: 'js-no-sort', orderable: false }
                ]
            });
        }
    };
});

$(document).ready(function () {
    function init_select2(selector) {
        $(selector).select2();
    };

    $("form").on("cocoon:after-insert", function (_, row) {
        field = $(row).find(".select2")
        init_select2(field);
    });

    $(".student-meeting-form").on('cocoon:before-insert', function (e, insertedItem) {
        insertedItem.removeClass('d-none');
    });
});